/**
 * @file default.js
 * @fileoverview Renders the default page.
 * @namespace default
 * @description The default page.
 * @module common/assets/pages/Page/default
 * @since 3.0.0
 */

import { i18n, loading, outputDiv } from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement.js";
import { loadingGif } from "commonAssets/lib/loadingGif.js";

/**
 * Default page function.
 *
 * @param {Object} params - The parameters object.
 * @param {string} params.slug - The slug of the page.
 * @param {Array} params.pages - The array of pages.
 */
export const defaultPage = (params) => {
    console.log("[Default Page] ...");

    // Get the slug and page object from the parameters.
    const slug = params.slug;
    const page = params.pages.find((page) => page.PageName === slug);

    // Create the page title and page body elements.
    const pageTitle = createElement(
        "h2",
        { class: "page-title mt-2 mb-4" },
        [],
        page.PageTitle
    );
    const pageBody = createElement("div", { class: "page-body" });

    // Create the page content element.
    const pageContent = createElement(
        "div",
        { class: "page-content" },
        [],
        page.PageContent
    );
    pageBody.appendChild(pageContent);

    // Create the page div element.
    const pageDiv = createElement("div", { class: "page-div" }, [
        pageTitle,
        pageBody,
    ]);
    outputDiv.appendChild(pageDiv);

    loadingGif(loading, "hide", 250);
};
